import type { Units } from '@turf/turf';

import { DRAWING_MODE, MAP_LAYER } from 'components/Map/constants';
import { GEOJSON_BOUNDARY_TYPE } from 'components/Map/hooks/useFeatures/constants';

export {
    GEOJSON_FEATURE,
    GEOJSON_FEATURE_TYPE,
    GEOJSON_POLYGON_TYPE,
    GEOJSON_PROPERTY
} from 'components/Map/hooks/useFeatures/constants';

export { MAP_LAYER } from 'components/Map/constants';

export { MAP_ACTION_TYPE } from 'components/Map/hooks/useUndo/constants';

export const CIRCLE_MIN_RADIUS_METERS = 1;

export const CIRCLE_STEPS = 64;

export const CIRCLE_UNITS = 'meters' as Units;

export const CIRCLE_OPTIONS = { units: CIRCLE_UNITS };

export const CIRCLE_STEP_OPTIONS = { steps: CIRCLE_STEPS, units: CIRCLE_UNITS };

export const DRAWING_MODE_TO_GEOJSON_BOUNDARY_TYPE_MAP = {
    [DRAWING_MODE.APPLY]: GEOJSON_BOUNDARY_TYPE.APPLY,
    [DRAWING_MODE.NO_ENTRY]: GEOJSON_BOUNDARY_TYPE.NO_ENTRY
};

export const DRAWING_LAYERS_BY_MODE = {
    [DRAWING_MODE.APPLY]: {
        centerRadiusLineLayer: MAP_LAYER.DRAWING_CIRCLE_RADIUS_LINE,
        circleFillLayer: MAP_LAYER.DRAWING_BOUNDARY_CIRCLE_FILL,
        circleOutlineLayer: MAP_LAYER.DRAWING_BOUNDARY_CIRCLE_OUTLINE,
        vertexLayer: MAP_LAYER.DRAWING_POINT
    },
    [DRAWING_MODE.NO_ENTRY]: {
        centerRadiusLineLayer: MAP_LAYER.DRAWING_CIRCLE_RADIUS_LINE,
        circleFillLayer: MAP_LAYER.DRAWING_OBSTACLE_CIRCLE_FILL,
        circleOutlineLayer: MAP_LAYER.DRAWING_OBSTACLE_CIRCLE_OUTLINE,
        vertexLayer: MAP_LAYER.DRAWING_POINT
    }
};

export { MAP_EVENT_TYPE } from 'components/Map/hooks/useMapEvents/constants';
